import { fold, map as emap } from 'fp-ts/lib/Either';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  useUserContext,
  IError,
  getRegistrations,
  IApiCallStatus,
  IDeaRegistration,
  getHeaders,
  ResponseCSOSHeaders,
} from '..';
import { compose as lcompose } from 'lodash/fp';

export function useDeaRegistrations() {
  const { user } = useUserContext();

  const [regs, setRegs] = useState<IDeaRegistration[]>([]);
  const [status, setStatus] = useState<IApiCallStatus>(null);

  useEffect(() => {
    lcompose(emap(handleRequest(setStatus)(setRegs)), getHeaders)(user);
  }, [user]);

  return { deaRegistrations: regs, getRegistrationsCallStatus: status };
}

//TODO handle error

const handleRequest =
  (setStatus: Dispatch<SetStateAction<IApiCallStatus>>) =>
  (setRegs: Dispatch<SetStateAction<IDeaRegistration[]>>) =>
  (hR: ResponseCSOSHeaders) =>
    getRegistrations(hR)
      .then(
        fold<IError, IDeaRegistration[], void>(
          console.error,
          lcompose(() => setStatus(true), setRegs)
        )
      )
      .catch(console.log);
